module.exports = __webpack_public_path__ + "img/curved-rail-vertical-right-top-backplates-remnants.2108b0e6.png";